import { Box, CircularProgress, makeStyles, Typography } from "@material-ui/core";
import { HelpOutlineTwoTone } from "@material-ui/icons";
import { useState } from "react";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import ConnectWalletDialog from "src/components/Header/ConnectedButton/ConnectWalletDialog";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import StrategyProvider from "src/context/strategyContext";
import useTravaBalance from "src/hooks/useTravaBalance";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";
import CreditScoreStrategyChart from "./CreditScoreStrategyChart";
import CreditScoreStrategyForm from "./CreditScoreStrategyForm";
import NoteDialog from "./NoteDialog";

const useStyle = makeStyles((theme) => ({
  paper: {
    padding: "10px 20px 10px 20px",
  },
  icon: {
    marginLeft: "0.25rem",
    cursor: "pointer",
  },
  connectText: {
    color: theme.palette.primary.main,
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
  },
}));

const CreditScoreStrategyLayout = () => {
  const cls = useStyle();
  const { address } = useWeb3Connect();

  const [seriesChart, setSeriesChart] = useState(null);
  const [dataChart, setDataChart] = useState(null);
  const [loadingChart, setLoadingChart] = useState(true);
  const [showNote, setShowNote] = useState(false);
  const [loadingIcon, setLoadingIcon] = useState(true);

  const travaBalance = useTravaBalance(address);
  const balance = travaBalance.bscTrava + travaBalance.ethTrava + travaBalance.ftmTrava;

  const [isOpenConnect, setIsOpenConnect] = useState(false);

  return (
    <Box>
      <CommonBreadcrumb
        config={[{ text: "scoring" }, { text: "credit score strategy", link: "/credit-score-strategy" }]}
      />
      <PaperWrapper title="Credit Score Strategy">
        <Box display="flex" alignItems="center" pb={1} pt={1}>
          <Typography variant="subtitle2">Credit Score Improvement Strategy</Typography>
          <HelpOutlineTwoTone fontSize="small" onClick={() => setShowNote(!showNote)} className={cls.icon} />
          {loadingIcon && address ? <CircularProgress size={20} /> : null}
        </Box>
        {!address ? (
          <Box pb={1}>
            <Typography color="textSecondary">
              Please{" "}
              <span onClick={() => setIsOpenConnect(true)} className={cls.connectText}>
                connect your wallet
              </span>{" "}
              to adjust your credit score parameters
            </Typography>
          </Box>
        ) : (
          <Box>
            <CreditScoreStrategyForm
              {...{ setLoadingChart, setSeriesChart, setDataChart, balance, setLoadingIcon }}
              accountAddress={address}
            />
            {loadingChart ? null : <CreditScoreStrategyChart {...{ seriesChart, dataChart }} />}
          </Box>
        )}
      </PaperWrapper>
      <NoteDialog {...{ showNote, setShowNote }} />
      <ConnectWalletDialog open={isOpenConnect} onClose={() => setIsOpenConnect(false)} />
    </Box>
  );
};

export default function CreditScoreStrategy() {
  return (
    <StrategyProvider>
      <CreditScoreStrategyLayout />
    </StrategyProvider>
  );
}
